export interface SpinnerProps {
  label?: string;
  size?: 'small' | 'medium' | 'large';
}

export function Spinner({ label = 'Đang tải', size = 'medium' }: SpinnerProps) {
  return (
    <div className={`spinner spinner--${size}`} role="status" aria-label={label}>
      <span className="spinner__ring" aria-hidden={true} />
      <span className="spinner__label">{label}</span>
    </div>
  );
}

export default Spinner;
